<template>
  <div class="web_bottom">
    <div class="w1600">
      <div class="logo">
        <img :src="$bindImg(form.phoneImage)" alt="" />

        <div class="text">
          <div class="item">
            <img
              src="@/assets/uploadfiles/web/icon24.png"
              alt=""
            />{{form.info1}}
          </div>
          <div class="item">
            <img
              src="@/assets/uploadfiles/web/icon25.png"
              alt=""
            />{{form.info2}}
          </div>
        </div>
      </div>

      <ul class="bot_nav">
        <li>
          <div class="nav_tit">业务布局</div>
          
        </li>
        <li>
          <div class="nav_tit" @click="$pushTo(`/web/news`)">新闻资讯</div>
           
          <a href="javascript:;" @click="$pushTo(`/web/news?id=${item.id}`)" v-for="item in listnewsType">{{item.title}}</a>
        </li>
        <li>
          <div class="nav_tit" @click="$pushTo(`/web/industry-style`)">行业风采</div>
        <a href="javascript:;" @click="$pushTo(`/web/industry-style?id=${item.id}`)" v-for="item in listhyfcType">{{item.title}}</a>
         
        </li>
        <li>
          <div class="nav_tit" @click="$pushTo(`/web/serve`)">行业服务</div>
              <a href="javascript:;" @click="$pushTo(`/web/serve?id=${item.id}`)" v-for="item in listhyfwType">{{item.title}}</a>
        </li>
        <li>
          <div class="nav_tit" @click="$pushTo(`/web/cooperation`)">商业合作</div>
          <a href="javascript:;" @click="$pushTo(`/web/cooperation`)" v-for="item in listsyhzType">{{item.title}}</a>
        </li>
        <li>
          <div class="nav_tit" @click="$pushTo(`/web/about-profile`)">关于我们</div>
          <a href="javascript:;" @click="$pushTo(`/web/about-profile`)">公司概况</a>
          <a href="javascript:;" @click="$pushTo(`/web/about-history`)">发展历程</a>
          <a href="javascript:;" @click="$pushTo(`/web/about-structure`)">组织架构</a>
          <a href="javascript:;" @click="$pushTo(`/web/about-recruit`)">人才招聘</a>
          <a href="javascript:;" @click="$pushTo(`/web/about-contactUs`)">联系我们</a>
        </li>
      </ul>

      <div class="code_box">
        <div class="item">
           <img :src="$bindImg(form.image2)" alt="">
          <p>北京兰麦服务号</p>
        </div>
        <div class="item">
          <img :src="$bindImg(form.image3)" alt="" />
          <p>兰麦教育订阅号</p>
        </div>
      </div>
    </div>
  </div>
  <div class="web_bottom2">
    <div class="w1600">
      <div class="filing">
        {{form.label}}
        <a href="https://beian.miit.gov.cn/" target="_blank" class="icp">{{form.illustrate}}</a>
      </div>

      <ul class="link_ul">
        <li @click="$pushTo(`/web/about-profile`)">关于我们</li>
        <li @click="$pushTo(`/web/about-contactUs`)">联系我们</li>
        <li @click="$pushTo(`/web/legalNotice`)">法律声明</li>
        <li @click="$pushTo(`/web/link`)">友情链接</li>
      </ul>
    </div>
  </div>
</template>


<script>
import { GetItemById } from "@/api/webSite/content";
import { GetPage as GetNewsType } from "@/api/contentcategory";
export default {
  data() {
    return {
        form:{},
        listnewsType:[],
        listhyfcType:[],
        listhyfwType:[],
        listsyhzType:[]
    };
  },
  created() {
     this.loadlistNewsTypeB()
     this.loadlistHyfcTypeB()
     this.loadlistHyfwTypeB()
     this.loadlistsyhzTypeB()
     this.loadinfo();
  },
  methods: {
     //新闻分类
     loadlistNewsTypeB() {
        var that = this
        var filter = {columnId:31}
        GetNewsType({
              pageIndex: 1, pageSize:99, filter: JSON.stringify(filter)
        })
        .then((res) => {
            that.listnewsType = res.body.items
            console.log("listnewsType",that.listnewsType)
        })
        .catch((err) => {

        });
     },
      //行业风采分类
     loadlistHyfcTypeB() {
        var that = this
        var filter = {columnId:32}
        GetNewsType({
              pageIndex: 1, pageSize:99, filter: JSON.stringify(filter)
        })
        .then((res) => {
            that.listhyfcType = res.body.items
            console.log("listhyfcType",that.listhyfcType)
        })
        .catch((err) => {

        });
     },
      //行业服务分类
     loadlistHyfwTypeB() {
        var that = this
        var filter = {columnId:33}
        GetNewsType({
              pageIndex: 1, pageSize:99, filter: JSON.stringify(filter)
        })
        .then((res) => {
            that.listhyfwType = res.body.items
            console.log("listhyfwType",that.listhyfwType)
        })
        .catch((err) => {

        });
     },
    //商业合作分类
     loadlistsyhzTypeB() {
        var that = this
        var filter = {columnId:35}
        GetNewsType({
              pageIndex: 1, pageSize:99, filter: JSON.stringify(filter)
        })
        .then((res) => {
            that.listsyhzType = res.body.items
            console.log("listsyhzType",that.listsyhzType)
        })
        .catch((err) => {

        });
     },
     loadinfo() {
        var that = this
        GetItemById({
            columnId: 14
        })
        .then((res) => {
            that.form = res.body
            console.log("webinfo",that.form)
        })
        .catch((err) => {

        });
     },
     
  },
};
 
</script>